export default [
	{
		path: '*',
		component: () => import('@/layouts/Default'),
		children: [{
			path: '',
			component: () => import('@/pages/Erro/404/Pages/Index'),
			name: '404',
			meta: {
				pai: 'Admin',
				title: 'siS - Erro',
				noCache: true,
				navigation: [{
					pagina: 'Home',
					class: 'ace-icon fa fa-home home-icon',
					active: false,
					url: '/'
				},
				{
					pagina: 'Erro 404',
					class: '',
					active: true,
					url: false
				}
				]
			}
		}]
	}
]